/* Muskoka menu behaviour: open-now status (Mon to Fri 9 to 5 ET), desktop panels, hover photo swaps, tracking, chat link. */
(function () {
  'use strict';
  var root = document.documentElement;

  // 1. Open now (America/Toronto)
  function setOpen() {
    var open = false, next = 'Monday';
    try {
      var p = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Toronto', weekday: 'short', hour: 'numeric', hour12: false }).formatToParts(new Date());
      var wd = p.filter(function (x) { return x.type === 'weekday'; })[0].value;
      var hr = parseInt(p.filter(function (x) { return x.type === 'hour'; })[0].value, 10) % 24;
      open = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].indexOf(wd) > -1 && hr >= 9 && hr < 17;
      // When closed, say when we are next in: today (weekday before 9), tomorrow (Sun to Thu after 5), otherwise Monday.
      if (!open) next = (['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].indexOf(wd) > -1 && hr < 9) ? 'today' : (['Sun', 'Mon', 'Tue', 'Wed', 'Thu'].indexOf(wd) > -1 ? 'tomorrow' : 'Monday');
    } catch (e) { return; }
    var force = /[?&]mk_open=(0|1)/.exec(location.search);
    if (force) open = force[1] === '1';
    var fn = /[?&]mk_next=(today|tomorrow|monday)/.exec(location.search); // preview helper
    if (fn) next = fn[1] === 'monday' ? 'Monday' : fn[1];
    document.querySelectorAll('[data-mk-closed]').forEach(function (n) {
      n.textContent = n.getAttribute('data-mk-closed') === 'back' ? 'Back ' + next + ' 9 AM ET' : (next === 'today' ? 'Call at 9 AM' : 'Call ' + next);
    });
    root.setAttribute('data-mk-open', open ? '1' : '0');
    document.querySelectorAll('.mkn-open-only,.mkn-closed-only,.mkn-status').forEach(function (n) { n.hidden = false; });
  }
  setOpen();
  setInterval(setOpen, 60000);

  // 2. Tracking (same event names the quote form uses)
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-mk-track]');
    if (!a) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: a.getAttribute('data-mk-track'), cta_location: a.getAttribute('data-mk-loc') || 'menu' });
  }, true);

  // 3. Desktop panels
  var nav = document.querySelector('[data-mk-nav]');
  if (nav) {
    root.classList.add('mkn-on');
    var mega = nav.querySelector('[data-mk-mega]');
    document.body.appendChild(mega); // escape any clipping or transformed ancestor in the header
    var btns = nav.querySelectorAll('[data-mk-panel]');
    var closeT;
    var header = document.querySelector('header.header, header, .header');
    function place() {
      var h = nav.closest('header') || header;
      var r = h ? h.getBoundingClientRect() : { bottom: 80 };
      mega.style.top = Math.max(0, r.bottom) + 'px';
    }
    function show(id) {
      clearTimeout(closeT);
      place();
      mega.hidden = false;
      mega.querySelectorAll('[data-mk-panelbox]').forEach(function (p) { p.hidden = p.getAttribute('data-mk-panelbox') !== id; });
      btns.forEach(function (b) { b.setAttribute('aria-expanded', b.getAttribute('data-mk-panel') === id ? 'true' : 'false'); });
    }
    function hide() {
      mega.hidden = true;
      btns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    }
    function later() { clearTimeout(closeT); closeT = setTimeout(hide, 180); }
    btns.forEach(function (b) {
      var id = b.getAttribute('data-mk-panel');
      b.addEventListener('mouseenter', function () { show(id); });
      b.addEventListener('focus', function () { show(id); });
      b.addEventListener('click', function (e) {
        // Mouse users: the click follows the link. Touch users (no hover): first tap opens the panel.
        if (window.matchMedia && window.matchMedia('(hover: hover)').matches) return;
        e.preventDefault();
        b.getAttribute('aria-expanded') === 'true' ? hide() : show(id);
      });
      b.addEventListener('mouseleave', later);
    });
    nav.querySelectorAll('.mkn-nav__list a:not([data-mk-panel])').forEach(function (a) { a.addEventListener('mouseenter', hide); });
    mega.addEventListener('mouseenter', function () { clearTimeout(closeT); });
    mega.addEventListener('mouseleave', later);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
    document.addEventListener('click', function (e) { if (!nav.contains(e.target) && !mega.contains(e.target)) hide(); });
    window.addEventListener('scroll', function () { if (!mega.hidden) place(); }, { passive: true });
    window.addEventListener('resize', hide);
    var qp = /[?&]mk_panel=(saunas|heat|plunge)/.exec(location.search); // preview helper: open a panel on load
    if (qp) setTimeout(function () { show(qp[1]); }, 1200);

    try { var pj = document.getElementById('mk-menu-photos'); window.mkMenuPhotos = pj ? JSON.parse(pj.textContent).photos : {}; } catch (e) { window.mkMenuPhotos = {}; }
    // 4. Hover photo swap on brand links
    mega.querySelectorAll('.mkn-tile').forEach(function (t) {
      var ov = t.querySelector('img.mkn-hvimg'); if (!ov) return;
      t.querySelectorAll('.mkn-subs a[data-img]').forEach(function (a) {
        var on = function () {
          var c = (window.mkMenuPhotos || {})[a.getAttribute('data-key')] || {};
          ov.src = c.src || a.getAttribute('data-img');
          ov.style.objectPosition = c.focal || '';
          var z = (c.zoom || 100) / 100, x = c.x || 0, y = c.y || 0;
          ov.style.transform = (z !== 1 || x || y) ? 'translate(' + x + '%,' + y + '%) scale(' + z + ')' : '';
          ov.classList.add('on');
        };
        var off = function () { ov.classList.remove('on'); };
        a.addEventListener('mouseenter', on); a.addEventListener('focus', on);
        a.addEventListener('mouseleave', off); a.addEventListener('blur', off);
      });
      t.addEventListener('mouseleave', function () { ov.classList.remove('on'); });
    });
  }

  // 5. Chat link (Shopify Inbox bubble). Shown only when the bubble exists on the page.
  function findChat() { return document.querySelector('inbox-online-store-chat, shopify-chat'); }
  function wireChat() {
    var host = findChat();
    document.querySelectorAll('[data-mk-chat]').forEach(function (p) {
      if (!host) return;
      p.hidden = false;
      var b = p.querySelector('button');
      if (b && !b.__mk) {
        b.__mk = 1;
        b.addEventListener('click', function () {
          try {
            var h = findChat(), sr = h && h.shadowRoot;
            var btn = (sr && sr.querySelector('button')) || (h && h.querySelector('button'));
            if (btn) btn.click();
          } catch (e) {}
        });
      }
    });
  }
  wireChat(); setTimeout(wireChat, 2500); setTimeout(wireChat, 6000);
})();
